import { render } from "./Addactivity.vue?vue&type=template&id=a2051d4a&scoped=true"
import script from "./Addactivity.vue?vue&type=script&lang=js"
export * from "./Addactivity.vue?vue&type=script&lang=js"

import "./Addactivity.vue?vue&type=style&index=0&id=a2051d4a&lang=scss&scoped=true"
import "./Addactivity.vue?vue&type=style&index=1&id=a2051d4a&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2051d4a"]])

export default __exports__